import { Formatter } from 'gf-ui';
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';

const InputText = ({kid, domanda, domande, mostraSe, value, placeholder, onChange}) => {    

  const [visibile, mostra] = useState(false)


  const selVal = (val) => {                
    onChange(kid, val)            
  }
  
  useEffect(()=>{             
    if( mostraSe.length === 0 ){
      mostra(true);
    }else{        
      let mostraDomanda = [];
      
      Object.keys(mostraSe).forEach( idx => {
        const domanda_rif = mostraSe[idx];                
        
        Object.keys(domande).forEach( id_domanda => {          
          if( domanda_rif.ID_MA_CSS_D_R === parseInt(domande[id_domanda].val) && (domande[id_domanda]?.ARR_RISPOSTE?.find( r => Formatter.getBoolean(r.FLG_SELEZIONATA)) || false)){
            mostraDomanda.push(true);
          }
        });        
      })

      mostra(mostraDomanda.length === mostraSe.length)
    }    
  }, [domande, mostraSe])

  return (
    <>            
      { visibile && (
      <Form.Group className="mb-3 form-group">
        <Form.Label>{domanda}</Form.Label>
        <Form.Control rows={4}                    
                      aria-label={domanda}                     
                      onChange={(e) => selVal(e.target.value)}
                      value={value} 
                      placeholder={placeholder}
                      required={true}                       
                      className={(value !== undefined && value !== "") ? "is-valid" : ""}>      
        </Form.Control>
      </Form.Group>
      )}
    </>
  )
}

export default InputText;